import { ThemeProvider } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import DarkTheme from './styles/theme';
import './App.scss';
import RootScreen from './screens/RootScreen';
import HomeScreen from './screens/HomeScreen';
import setupIcons from './styles/icons';
import YouTubeContentIdClaimScreen from './screens/YouTubeContentIdClaimScreen';
import ContactScreen from './screens/ContactScreen';
import TunesScreen from './screens/TunesScreen';
import { ModalProvider } from './contexts/modalContext';
import ModalManager from './components/modal/modalManager';
import { SongPlayerProvider } from './contexts/songPlayerContext';
import SongPlayer from './components/songPlayer';
import AboutScreen from './screens/AboutScreen';
import { QuickFilterPortalProvider } from './contexts/quickFilterPortalContext';
import AlbumScreen from './screens/AlbumScreen';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import TagScreen from './screens/TagScreen';
import FaqScreen from './screens/FaqScreen';
import { ScrollProvider } from './contexts/scrollContext';
import './styles/styles.scss';
import './styles/animation.scss';
import ScrollToTopOnNav from './components/scrollToTopOnNav';
import AffiliateScreen from './screens/AffiliateScreen';
import BlogScreen from './screens/BlogScreen';
import BlogPostScreen from './screens/BlogPostScreen';
import { LicenseProvider } from './contexts/licenseContext';
import LicenseSuccessScreen from './screens/LicenseSuccessScreen';
import LicenseCancelScreen from './screens/LicenseCancelScreen';

function App() {
	setupIcons();
	LicenseInfo.setLicenseKey('9583249a10de9ff1ee1faa7b0964e48bTz04MDc0MixFPTE3MzQ0MDIzODkwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y');
	dayjs.extend(utc.default);

	return (
		<ThemeProvider theme={DarkTheme}>
			<ScrollProvider>
				<QuickFilterPortalProvider>
					<Router>
						<ScrollToTopOnNav />
						<LicenseProvider>
							<SongPlayerProvider>
								<ModalProvider>
									<Routes>
										<Route path="/" element={<RootScreen />}>
											<Route index element={<HomeScreen />} />
											<Route path="tunes" element={<TunesScreen />} />
											<Route path="albums" element={<AlbumScreen />} />
											<Route path="tags" element={<TagScreen />} />
											<Route path="blog" element={<BlogScreen />} />
											<Route path="blog/:slug" element={<BlogPostScreen />} />
											<Route path="faq" element={<FaqScreen />} />
											<Route path="youtube" element={<YouTubeContentIdClaimScreen />} />
											<Route path="contact" element={<ContactScreen />} />
											<Route path="about" element={<AboutScreen />} />
											<Route path="affiliates" element={<AffiliateScreen />} />
											<Route path="license/success" element={<LicenseSuccessScreen />} />
											<Route path="license/cancel" element={<LicenseCancelScreen />} />
										</Route>
									</Routes>
									<ModalManager />
									<SongPlayer />
								</ModalProvider>
							</SongPlayerProvider>
						</LicenseProvider>
					</Router>
				</QuickFilterPortalProvider>
			</ScrollProvider>
		</ThemeProvider>
	);
}

export default App;
